// !! Deprecated !!
// トークンの扱いはSSOクライアントで行うのでこのサービスは不要です！！
// !! Deprecated !!

// 認証トークン（+ 付随するリフレッシュトークンなども）を扱うサービス

import Vue from 'vue'
import { post } from 'axios'

Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.token) this.$token = options.token
    else if (options.parent && options.parent.$token)
      this.$token = options.parent.$token
  },
})

const development = process.env.NODE_ENV === 'development'
const storage = localStorage

const SAVE_KEY_USER_ID = development ? 'DEV_FROG_USER_ID' : 'FROG_USER_ID'
const SAVE_KEY_COMPANY_CODE = development
  ? 'DEV_FROG_COMPANY_CODE'
  : 'FROG_COMPANY_CODE'
const SAVE_KEY_LOGIN_ID = development ? 'DEV_FROG_LOGIN_ID' : 'FROG_LOGIN_ID'
const SAVE_KEY_ACCESS_TOKEN = development
  ? 'DEV_FROG_ACCESS_TOKEN'
  : 'FROG_ACCESS_TOKEN'
const SAVE_KEY_REFRESH_TOKEN = development
  ? 'DEV_FROG_REFRESH_TOKEN'
  : 'FROG_REFRESH_TOKEN'
const SAVE_KEY_REFRESH_URL = development
  ? 'DEV_FROG_REFRESH_URL'
  : 'FROG_REFRESH_URL'

export default {
  /**
   * トークン、およびその付随情報をローカルに保存する
   */
  saveToken({
    userId,
    loginId,
    companyCode,
    accessToken,
    refreshToken,
    refreshUrl,
  }) {
    // 保存場所がローカルストレージなので実際には同期処理だが、
    // 保存場所を変えたとき保存や取得が非同期処理になることが多々あると思うので
    // 原則インターフェースは全て非同期処理にする。
    storage.setItem(SAVE_KEY_USER_ID, userId)
    storage.setItem(SAVE_KEY_COMPANY_CODE, companyCode)
    storage.setItem(SAVE_KEY_LOGIN_ID, loginId)
    storage.setItem(SAVE_KEY_ACCESS_TOKEN, accessToken)
    storage.setItem(SAVE_KEY_REFRESH_TOKEN, refreshToken)
    storage.setItem(SAVE_KEY_REFRESH_URL, refreshUrl)
    return Promise.resolve()
  },
  /**
   * ローカルに保存されたトークン、およびその付随情報を取得する
   */
  retrieveToken() {
    return Promise.resolve({
      userId: storage.getItem(SAVE_KEY_USER_ID),
      companyCode: storage.getItem(SAVE_KEY_COMPANY_CODE),
      loginId: storage.getItem(SAVE_KEY_LOGIN_ID),
      accessToken: storage.getItem(SAVE_KEY_ACCESS_TOKEN),
      refreshToken: storage.getItem(SAVE_KEY_REFRESH_TOKEN),
      refreshUrl: storage.getItem(SAVE_KEY_REFRESH_URL),
    })
  },
  /**
   * アクセストークンのリフレッシュ
   *
   * アクセストークンのリフレッシュにはリフレッシュトークンと、発行対象のユーザIDが
   * 必要です。
   */
  refreshAccessToken(userId, refreshToken, refreshUrl) {
    // 下手にRepositoryとかのAxiosを使うとinterceptorsに無駄にintercepteされそうなので、
    // 生のaxiosを使う（なんか汚いが、、、）。
    return post(refreshUrl, {
      userId,
      refreshToken,
    })
      .then(res => res.data)
      .then(data =>
        this.saveToken({
          userId,
          ...data,
        }),
      )
      .catch(e => {
        throw e
      })
  },
  /**
   * 保存されているトークンを削除する
   */
  removeToken() {
    storage.removeItem(SAVE_KEY_USER_ID)
    storage.removeItem(SAVE_KEY_COMPANY_CODE)
    storage.removeItem(SAVE_KEY_LOGIN_ID)
    storage.removeItem(SAVE_KEY_ACCESS_TOKEN)
    storage.removeItem(SAVE_KEY_REFRESH_TOKEN)
    storage.removeItem(SAVE_KEY_REFRESH_URL)
    return Promise.resolve()
  },
}
